<template>
  <span>{{localTime}}</span>
</template>

<script>
  import moment from 'moment';

  export default {
    name: "clock",
    data() {
      return {
        utcTime: moment.utc().format('HH:mm'),
        localTime: moment().format('HH:mm'),
        intervalUpdate: undefined
      };
    },
    methods: {
      updateClock() {
        this.utcTime = moment.utc().format('HH:mm');
        this.localTime = moment().format('HH:mm');
      }
    },
    created() {
      this.updateClock();
    },
    mounted() {
      const that = this;
      this.intervalUpdate = setInterval(() => {
        that.updateClock();
      }, 5 * 1000);
    },
    unmounted() {
      clearInterval(this.intervalUpdate);
    }
  }
</script>

<style scoped>

</style>